/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuySharedBreadcrumbs_buyPage = {
    readonly breadcrumbs: ReadonlyArray<{
        readonly path: string | null;
        readonly displayName: string | null;
    } | null> | null;
    readonly " $refType": "BuySharedBreadcrumbs_buyPage";
};
export type BuySharedBreadcrumbs_buyPage$data = BuySharedBreadcrumbs_buyPage;
export type BuySharedBreadcrumbs_buyPage$key = {
    readonly " $data"?: BuySharedBreadcrumbs_buyPage$data;
    readonly " $fragmentRefs": FragmentRefs<"BuySharedBreadcrumbs_buyPage">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "BuySharedBreadcrumbs_buyPage",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "breadcrumbs",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchBrowseBreadcrumbs",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "path",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "displayName",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '109989b1786963f0a6ed35f51070ffd7';
export default node;
